/* eslint-disable */
import Long from 'long'
import * as _m0 from 'protobufjs/minimal'

export const protobufPackage = 'Reality.Reality.Api'

/** レア度確定タイプ */
export enum GachaRarityGuaranteeType {
  /** GACHA_RARITY_GUARANTEE_TYPE_NONE - なし */
  GACHA_RARITY_GUARANTEE_TYPE_NONE = 0,
  /** GACHA_RARITY_GUARANTEE_TYPE_RARE3 - 星3以上確定 */
  GACHA_RARITY_GUARANTEE_TYPE_RARE3 = 1,
  /** GACHA_RARITY_GUARANTEE_TYPE_RARE3_RARE4UP - 星3以上確定(星4確率アップ) */
  GACHA_RARITY_GUARANTEE_TYPE_RARE3_RARE4UP = 2,
  /** GACHA_RARITY_GUARANTEE_TYPE_RARE4 - 星4確定 */
  GACHA_RARITY_GUARANTEE_TYPE_RARE4 = 3,
  UNRECOGNIZED = -1,
}

export function gachaRarityGuaranteeTypeFromJSON(
  object: any
): GachaRarityGuaranteeType {
  switch (object) {
    case 0:
    case 'GACHA_RARITY_GUARANTEE_TYPE_NONE':
      return GachaRarityGuaranteeType.GACHA_RARITY_GUARANTEE_TYPE_NONE
    case 1:
    case 'GACHA_RARITY_GUARANTEE_TYPE_RARE3':
      return GachaRarityGuaranteeType.GACHA_RARITY_GUARANTEE_TYPE_RARE3
    case 2:
    case 'GACHA_RARITY_GUARANTEE_TYPE_RARE3_RARE4UP':
      return GachaRarityGuaranteeType.GACHA_RARITY_GUARANTEE_TYPE_RARE3_RARE4UP
    case 3:
    case 'GACHA_RARITY_GUARANTEE_TYPE_RARE4':
      return GachaRarityGuaranteeType.GACHA_RARITY_GUARANTEE_TYPE_RARE4
    case -1:
    case 'UNRECOGNIZED':
    default:
      return GachaRarityGuaranteeType.UNRECOGNIZED
  }
}

export function gachaRarityGuaranteeTypeToJSON(
  object: GachaRarityGuaranteeType
): string {
  switch (object) {
    case GachaRarityGuaranteeType.GACHA_RARITY_GUARANTEE_TYPE_NONE:
      return 'GACHA_RARITY_GUARANTEE_TYPE_NONE'
    case GachaRarityGuaranteeType.GACHA_RARITY_GUARANTEE_TYPE_RARE3:
      return 'GACHA_RARITY_GUARANTEE_TYPE_RARE3'
    case GachaRarityGuaranteeType.GACHA_RARITY_GUARANTEE_TYPE_RARE3_RARE4UP:
      return 'GACHA_RARITY_GUARANTEE_TYPE_RARE3_RARE4UP'
    case GachaRarityGuaranteeType.GACHA_RARITY_GUARANTEE_TYPE_RARE4:
      return 'GACHA_RARITY_GUARANTEE_TYPE_RARE4'
    default:
      return 'UNKNOWN'
  }
}

export interface RarityGuarantee {
  /** 何回目にレア度確定するか */
  drawCount: number
  /** レア度確定タイプ */
  type: GachaRarityGuaranteeType
  /** レア度確定ウェイトのセットID（/gacha/drawでServerに送る） */
  weightSetId: number
}

function createBaseRarityGuarantee(): RarityGuarantee {
  return { drawCount: 0, type: 0, weightSetId: 0 }
}

export const RarityGuarantee = {
  encode(
    message: RarityGuarantee,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.drawCount !== 0) {
      writer.uint32(8).int64(message.drawCount)
    }
    if (message.type !== 0) {
      writer.uint32(16).int32(message.type)
    }
    if (message.weightSetId !== 0) {
      writer.uint32(24).int64(message.weightSetId)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RarityGuarantee {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRarityGuarantee()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          message.drawCount = longToNumber(reader.int64() as Long)
          break
        case 2:
          message.type = reader.int32() as any
          break
        case 3:
          message.weightSetId = longToNumber(reader.int64() as Long)
          break
        default:
          reader.skipType(tag & 7)
          break
      }
    }
    return message
  },

  fromJSON(object: any): RarityGuarantee {
    return {
      drawCount: isSet(object.drawCount) ? Number(object.drawCount) : 0,
      type: isSet(object.type)
        ? gachaRarityGuaranteeTypeFromJSON(object.type)
        : 0,
      weightSetId: isSet(object.weightSetId) ? Number(object.weightSetId) : 0,
    }
  },

  toJSON(message: RarityGuarantee): unknown {
    const obj: any = {}
    message.drawCount !== undefined &&
      (obj.drawCount = Math.round(message.drawCount))
    message.type !== undefined &&
      (obj.type = gachaRarityGuaranteeTypeToJSON(message.type))
    message.weightSetId !== undefined &&
      (obj.weightSetId = Math.round(message.weightSetId))
    return obj
  },

  fromPartial<I extends Exact<DeepPartial<RarityGuarantee>, I>>(
    object: I
  ): RarityGuarantee {
    const message = createBaseRarityGuarantee()
    message.drawCount = object.drawCount ?? 0
    message.type = object.type ?? 0
    message.weightSetId = object.weightSetId ?? 0
    return message
  },
}

declare var self: any | undefined
declare var window: any | undefined
declare var global: any | undefined
var globalThis: any = (() => {
  if (typeof globalThis !== 'undefined') return globalThis
  if (typeof self !== 'undefined') return self
  if (typeof window !== 'undefined') return window
  if (typeof global !== 'undefined') return global
  throw 'Unable to locate global object'
})()

type Builtin =
  | Date
  | Function
  | Uint8Array
  | string
  | number
  | boolean
  | undefined

export type DeepPartial<T> = T extends Builtin
  ? T
  : T extends Array<infer U>
  ? Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U>
  ? ReadonlyArray<DeepPartial<U>>
  : T extends {}
  ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>

type KeysOfUnion<T> = T extends T ? keyof T : never
export type Exact<P, I extends P> = P extends Builtin
  ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & Record<
        Exclude<keyof I, KeysOfUnion<P>>,
        never
      >

function longToNumber(long: Long): number {
  if (long.gt(Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error('Value is larger than Number.MAX_SAFE_INTEGER')
  }
  return long.toNumber()
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any
  _m0.configure()
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined
}
